/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { useHistory } from 'react-router-dom';

import { FicheBar /* , useFicheServiceStatus */ } from '@mairistem/fiche';

import { Popup, Menu, Button, Image } from '@mairistem/composants';
import { useHubeeNavigationStore } from '@mairistem/administres-utils';

import ModalEditionRecensement from '@/components/Common/ModalEditionRecensement';
import ModalDocumentsRecense from '@/components/Common/ModalDocumentsRecense';
import ModalHistoriqueRecense from '@/components/Common/ModalHistoriqueRecense';

// import { recenseFicheService } from '@/services';
import { baseUrlApp } from '@/routes';
import { type Individu, ListeRecensement } from '@/types';

import hubee from '../../../assets/images/hubee.png';

interface RecenseFicheBarProps {
  identifiant?: number | string;
  recense?: Individu;
}

const RecenseFicheBar = (props: RecenseFicheBarProps) => {
  const { identifiant, recense, ...rest } = props;

  const { nomFamille, prenom } = recense || {};

  const [openModalEdition, setOpenModalEdition] = React.useState(false);

  const [openModalDocuments, setOpenModalDocuments] = React.useState(false);

  const [openModalHistorique, setOpenModalHistorique] = React.useState(false);

  const history = useHistory();
  const setProvenance = useHubeeNavigationStore((state) => state.setProvenance);

  const handleCreate = React.useCallback(() => {
    history.push(`${baseUrlApp}recenses/assistant`);

    return false;
  }, [history]);

  // const { updated } = useFicheServiceStatus(recenseFicheService, identifiant);

  const isNumerote = !!recense?.numeroRecensement;

  return (
    <>
      <FicheBar
        {...rest}
        key="RecenseFicheBar"
        type="recense"
        identifiant={identifiant}
        // service={recenseFicheService}
        onCreating={handleCreate}
        canDraft={false}
        canDelete={!isNumerote}
      >
        {isNumerote && (
          <Popup
            data-testid="fiche-bar-bouton-supprimer"
            key="ficheButtonDelete"
            position="bottom left"
            trigger={
              <span>
                <Menu.Item
                  as={Button}
                  className="fiche-bar-button"
                  data-testid="fiche-bar-bouton-supprimer"
                  icon="trash"
                  disabled
                />
              </span>
            }
            content="Impossible de supprimer un recensé numéroté"
          />
        )}
        {/* {
        !updated && ( */}
        <Popup
          data-testid="fiche-bar-bouton-imprimer"
          key="ficheButtonPrint"
          position="bottom left"
          trigger={
            <span>
              <Menu.Item
                as={Button}
                className="fiche-bar-button"
                data-testid="fiche-bar-bouton-imprimer"
                icon="print"
                disabled={recense?.recensement === ListeRecensement.NonRecenses}
                onClick={() => {
                  setOpenModalEdition(true);
                }}
              />
            </span>
          }
          content={
            recense?.recensement === ListeRecensement.NonRecenses
              ? "L'impression n'est pas disponible pour les individus non recensés"
              : 'Imprimer la fiche'
          }
        />
        <Popup
          data-testid="fiche-bar-bouton-documents"
          key="ficheButtonDocuments"
          position="bottom left"
          trigger={
            <Menu.Item
              as={Button}
              className="fiche-bar-button"
              data-testid="fiche-bar-bouton-documents"
              icon="briefcase"
              style={{ marginLeft: '5rem' }}
              onClick={() => {
                setOpenModalDocuments(true);
              }}
            />
          }
          content="Documents relatifs à l'individu"
        />
        <Popup
          data-testid="fiche-bar-bouton-historique"
          key="ficheButtonHistorique"
          position="bottom left"
          trigger={
            <Menu.Item
              as={Button}
              className="fiche-bar-button"
              data-testid="fiche-bar-bouton-historique"
              icon="history"
              onClick={() => {
                setOpenModalHistorique(true);
              }}
            />
          }
          content="Historique des changements de liste "
        />
        {recense?.identifiantTeledossier && (
          <Popup
            data-testid="fiche-bar-bouton-hubee"
            key="ficheButtonHubee"
            position="bottom left"
            trigger={
              <Menu.Item
                as={Button}
                className="fiche-bar-button"
                data-testid="fiche-bar-bouton-hubee"
                onClick={() => {
                  setProvenance('liste', history.location.pathname);
                  history.push(
                    `${baseUrlApp}hubee/${recense.identifiantTeledossier}`,
                  );
                }}
              >
                <Image
                  src={hubee}
                  style={{
                    borderRadius: '20px',
                    height: 25,
                    width: 25,
                  }}
                />
              </Menu.Item>
            }
            content="Voir le télédossier HubEE"
          />
        )}
        {/* )
      } */}
      </FicheBar>
      {openModalEdition && (
        <ModalEditionRecensement
          identifiant={identifiant}
          nomFamille={nomFamille}
          prenom={prenom}
          onClose={() => setOpenModalEdition(false)}
        />
      )}
      {openModalDocuments && identifiant && (
        <ModalDocumentsRecense
          identifiant={identifiant}
          nomFamille={nomFamille}
          prenom={prenom}
          onClose={() => setOpenModalDocuments(false)}
        />
      )}
      {openModalHistorique && (
        <ModalHistoriqueRecense
          nomFamille={nomFamille}
          prenom={prenom}
          tracabiliteIndividu={recense?.tracabiliteIndividu}
          onClose={() => setOpenModalHistorique(false)}
        />
      )}
    </>
  );
};

export default RecenseFicheBar;
